module.exports = __webpack_public_path__ + "img/kankou_10.c70dfb75.jpg";